import React from 'react';
import { Button } from './Button';
import { UsersIcon, TrophyIcon, ClipboardListIcon, CreditCardIcon } from 'lucide-react';
export function TeamBuyersSection() {
  const benefits = [{
    title: 'Bulk Pricing',
    description: 'Special discounts for schools and clubs ordering in volume.',
    icon: <UsersIcon className="w-6 h-6" data-id="element-219" />
  }, {
    title: 'Tournament Equipment',
    description: 'Full system rentals and purchases for event organizers.',
    icon: <TrophyIcon className="w-6 h-6" data-id="element-220" />
  }, {
    title: 'Custom Quotes',
    description: 'Personalized equipment packages tailored to your needs.',
    icon: <ClipboardListIcon className="w-6 h-6" data-id="element-221" />
  }, {
    title: 'Financing Options',
    description: 'Flexible payment plans to help you equip your team today.',
    icon: <CreditCardIcon className="w-6 h-6" data-id="element-222" />
  }];
  return <section className="py-20 bg-blue-900 text-white relative overflow-hidden" data-id="element-223">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-224">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMSIvPjwvc3ZnPg==')]" data-id="element-225"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-226">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-227">
          <div className="lg:w-1/2" data-id="element-228">
            <h2 className="text-3xl sm:text-4xl font-black uppercase tracking-tight mb-4" data-id="element-229">
              Outfitting Teams, Clubs & Tournaments
            </h2>
            <div className="w-24 h-1 bg-red-500 mb-6" data-id="element-230"></div>
            <p className="text-blue-100 text-lg mb-8 font-medium" data-id="element-231">
              We specialize in supporting larger organizations. Whether you're
              upgrading your dojang's gear or hosting a major tournament, we
              have the inventory, expertise, and pricing to support you.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-232">
              <Button variant="primary" className="bg-red-600 hover:bg-red-700 focus:ring-red-600 border-none" data-id="element-233">
                Request a Quote
              </Button>
              <Button variant="outline" data-id="element-234">Learn About Financing</Button>
            </div>
          </div>

          <div className="lg:w-1/2 grid grid-cols-1 sm:grid-cols-2 gap-6 w-full" data-id="element-235">
            {benefits.map((benefit, index) => <div key={index} className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6 hover:bg-white/15 transition-colors" data-id="element-236">
                <div className="w-12 h-12 rounded-full bg-blue-500/30 flex items-center justify-center text-white mb-4" data-id="element-237">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-bold mb-2" data-id="element-238">{benefit.title}</h3>
                <p className="text-blue-100 text-sm" data-id="element-239">{benefit.description}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}